import AlertTriangle from '@crehana/compass.icons.outline/AlertTriangle';
import { Button } from '@crehana/compass.ui/button';

import { useCourseDetailTranslation } from '../hooks/useCourseDetailTranslation';

interface CourseNotFoundViewProps {
  onBack: () => void;
}

export const CourseNotFoundView: React.FC<CourseNotFoundViewProps> = ({
  onBack,
}) => {
  const { t } = useCourseDetailTranslation();

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-w-screen tw-h-screen tw-bg-gray-50">
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-bg-white tw-rounded-lg tw-shadow-md tw-max-w-md tw-text-center">
        <div className="tw-mb-2 tw-bg-alert-100 tw-p-1.2 tw-rounded-full tw-border-0.4 tw-border-alert-200 tw-border-solid">
          <AlertTriangle className="tw-fill-current tw-size-3.2 tw-text-alert-500" />
        </div>
        <h1 className="tw-font-subtitle1 tw-font-bold tw-mb-0.8 tw-text-gray-800">
          {t('ERROR_VIEW_COURSE_NOT_FOUND')}
        </h1>
        <p className="tw-font-body4 tw-text-neutral-light-700 tw-mb-2.8 tw-max-w-screen-sm">
          {t('ERROR_VIEW_COURSE_NOT_FOUND_DESCRIPTION')}
        </p>
        <Button type="button" variant="primary" onClick={onBack}>
          {t('ERROR_VIEW_COURSE_NOT_FOUND_BUTTON')}
        </Button>
      </div>
    </div>
  );
};
